import { get, toUpper } from 'lodash';
import { connect } from 'react-redux';

import CollectionBanner from 'components/CollectionBanner';
import { ALIGNMENT_OPTIONS, VARIATIONS } from 'components/CollectionBanner/constants';
import CustomCollectionModel from 'models/CustomCollectionModel';
import { getCustomCollectionData } from 'state/selectors/collection';

const mapStateToProps = state => {
  const customCollection = new CustomCollectionModel(getCustomCollectionData(state));
  const title = get(customCollection, ['name']);
  const supportingText = get(customCollection, ['supportingText']);

  const fullBleedAlignmentMobile = toUpper(
    get(customCollection, ['fullBleedAlignmentMobile'], ALIGNMENT_OPTIONS.CENTER)
  );
  const fullBleedAlignmentDesktop = toUpper(
    get(customCollection, ['fullBleedAlignmentDesktop'], ALIGNMENT_OPTIONS.CENTER)
  );

  let variation;
  let bannerSrc;
  let mobileBannerSrc;

  const condensedBannerSrc = get(customCollection, ['condensedImage', 'src']);
  const fullBleedMobileBannerSrc = get(customCollection, ['fullBleedImageMobile', 'src']);
  const fullBleedDesktopBannerSrc = get(customCollection, ['fullBleedImageDesktop', 'src']);

  if (!!condensedBannerSrc) {
    variation = VARIATIONS.CONDENSED;
    bannerSrc = condensedBannerSrc;
  } else if (!!fullBleedMobileBannerSrc || !!fullBleedDesktopBannerSrc) {
    variation = VARIATIONS.FULL_BLEED;
    bannerSrc = fullBleedDesktopBannerSrc;
    mobileBannerSrc = fullBleedMobileBannerSrc;
  } else {
    variation = VARIATIONS.CONTROL;
    bannerSrc = get(customCollection, ['image', 'src']);
  }

  return {
    title,
    description: customCollection.description,
    bannerSrc,
    mobileBannerSrc,
    bgColor: customCollection.bannerBgColor,
    variation,
    eyebrow: supportingText,
    fullBleedAlignmentMobile,
    fullBleedAlignmentDesktop,
  };
};

export default connect(mapStateToProps)(CollectionBanner);
